<template>
  <div>
    <div class="display-flex">
      <div class="column-left">
        <sidebar-component />
      </div>
      <div class="column-right">
        <navbar-component />
        <div
          class="container-scroll"
          :style="{ height: `${screenHeight}px` }"
        >
          <div class="bg-container">
            <order-detail-content-layout :texts="texts" />
          </div>
          <footer-component />
        </div>
      </div>
    </div>
    <delete-component />
    <sidebar-open-component />
    <order-detail-update-status-layout :texts="texts" />
    <gallery-component />
    <order-detail-accept-order-layout />
    <order-detail-reject-order-layout />
  </div>
</template>

<script>
export default {
  name: "OrderInProcessView",
  data() {
    return {
      //VARIABLES
      texts: "",
      screenHeight: 0,
    };
  },
  beforeMount() {
    this.texts = FILE.orders[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize: function () {
      this.screenHeight = window.innerHeight - 64;
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.orders[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.column-left {
  width: 80px;
}

.column-right {
  width: calc(100% - 80px);
}

.container-scroll {
  overflow-y: auto;
  background: #f2f2f4 0% 0% no-repeat padding-box;
}

.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
}
</style>